<template>
  <div
    class="lp-button-group ly-row ly-no-gap"
    :class="vertical ? 'lp-button-group-v' : 'lp-button-group-h'"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'lp-button-group',
  props: {
    vertical: { type: Boolean },
  },
})
</script>
